import { apiHelper } from '../utils/apiHelper';

const API_URL = `${process.env.REACT_APP_API_URL}/api/admin/state`;

const headers = {
  "Content-Type": "multipart/form-data",
  "Accept": "application/json"
};

export const fetchStates = (payload) => apiHelper(API_URL, 'GET', payload);
export const createState = (payload) => apiHelper(API_URL, 'POST', payload, headers);
export const fetchState = (stateId) => apiHelper(`${API_URL}/${stateId}`, 'GET');
export const modifyState = (payload) => apiHelper(`${API_URL}/${payload.get('id')}`, 'POST', payload, headers);
export const deleteStateApi = (stateId) => apiHelper(`${API_URL}/${stateId}`, 'DELETE');
export const changeStatus = (stateId) => apiHelper(`${API_URL}/change-status/${stateId}`, 'POST');

